var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 8.74125L13.3 5.34125M6.7 11.3412L13.3 14.7412M1 10.0413C1 10.8369 1.31607 11.6 1.87868 12.1626C2.44129 12.7252 3.20435 13.0413 4 13.0413C4.79565 13.0413 5.55871 12.7252 6.12132 12.1626C6.68393 11.6 7 10.8369 7 10.0413C7 9.24561 6.68393 8.48255 6.12132 7.91994C5.55871 7.35733 4.79565 7.04126 4 7.04126C3.20435 7.04126 2.44129 7.35733 1.87868 7.91994C1.31607 8.48255 1 9.24561 1 10.0413ZM13 4.04126C13 4.83691 13.3161 5.59997 13.8787 6.16258C14.4413 6.72519 15.2044 7.04126 16 7.04126C16.7956 7.04126 17.5587 6.72519 18.1213 6.16258C18.6839 5.59997 19 4.83691 19 4.04126C19 3.24561 18.6839 2.48255 18.1213 1.91994C17.5587 1.35733 16.7956 1.04126 16 1.04126C15.2044 1.04126 14.4413 1.35733 13.8787 1.91994C13.3161 2.48255 13 3.24561 13 4.04126ZM13 16.0413C13 16.8369 13.3161 17.6 13.8787 18.1626C14.4413 18.7252 15.2044 19.0413 16 19.0413C16.7956 19.0413 17.5587 18.7252 18.1213 18.1626C18.6839 17.6 19 16.8369 19 16.0413C19 15.2456 18.6839 14.4825 18.1213 13.9199C17.5587 13.3573 16.7956 13.0413 16 13.0413C15.2044 13.0413 14.4413 13.3573 13.8787 13.9199C13.3161 14.4825 13 15.2456 13 16.0413Z",
    stroke: "#868889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.3f7b729f853d6b823887901e3712f609.svg";
export { ForwardRef as ReactComponent };